import { render, staticRenderFns } from "./DisTab.vue?vue&type=template&id=0982afe5&scoped=true"
import script from "./DisTab.vue?vue&type=script&lang=js"
export * from "./DisTab.vue?vue&type=script&lang=js"
import style0 from "./DisTab.vue?vue&type=style&index=0&id=0982afe5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0982afe5",
  null
  
)

export default component.exports